import { FC, useEffect } from 'react'

import { cn } from '@bem-react/classname'

import { useCountdown } from '@/hooks/useCountdown'

import './Timer.scss'

interface ITimerProps {
  className?: string
  end?: number
  onFinish?: () => void
}

const cnTimer = cn('Timer')

export const Timer: FC<ITimerProps> = ({ className, end, onFinish }) => {
  const { time, isFinished } = useCountdown(end ? end * 1000 : 0)

  useEffect(() => {
    if (isFinished && onFinish) onFinish()
  }, [isFinished])
  return (
    <div className={cnTimer(null, [className])}>
      <div className={cnTimer('time')}>{time}</div>
      <div className={cnTimer('text')}>
        after the time expires, the order will be canceled
      </div>
    </div>
  )
}
